import axios from "axios";
import { doPOSTRequest } from "./Api";
import ApiConfiguration from "./ApiConfiguration";

export interface ChatMessage {
  role: "user" | "assistant";
  content: string;
}

export interface AssistantFile {
  id: string;
  name: string;
}

export default class AssistantApi {
  // model: "hizli" | "dengeli" | "akilli"
  public static async chat(message: string, history: ChatMessage[], model: string) {
    return await doPOSTRequest("/assistant/chat", { message, history, model });
  }

  // PDF'i auth header ile blob olarak ceker (endpoint x-ozsk-auth-token istedigi
  // icin dogrudan URL acilamaz). Ortak yardimci.
  private static async fetchBlobUrl(id: string): Promise<string> {
    const base = ApiConfiguration.withBasePath(process.env.NODE_ENV || "local");
    const headers = ApiConfiguration.withDefaultHeaders();
    const res = await axios.get(base + "/assistant/file/" + id, {
      headers,
      responseType: "blob",
    });
    return window.URL.createObjectURL(
      new Blob([res.data], { type: "application/pdf" })
    );
  }

  // Yeni sekmede onizler (tarayicinin PDF goruntuleyicisi acilir).
  // Sekmeyi tiklama aninda acariz (popup engelleyici async window.open'i bloklar),
  // blob hazir olunca sekmeyi ona yonlendiririz.
  public static async openFile(id: string): Promise<void> {
    const win = window.open("", "_blank");
    const url = await AssistantApi.fetchBlobUrl(id);
    if (win) {
      win.location.href = url;
    } else {
      // Popup engellendiyse ayni sekmede ac.
      window.location.href = url;
    }
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  }

  // Diske indirir.
  public static async downloadFile(id: string, name: string): Promise<void> {
    const url = await AssistantApi.fetchBlobUrl(id);
    const a = document.createElement("a");
    a.href = url;
    a.download = name || "rapor.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
}
